import { ApiSource, Source } from "../model";

export function toSource(apiSource: ApiSource): Source {
  const baseSource = {
    fileId: apiSource.file_uuid,
    collectionId: apiSource.collection_uuid,
  };

  switch (apiSource.mimetype) {
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return {
        ...baseSource,
        mimetype: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        pages:
          typeof apiSource.mimetype_specific_metadata === "object" &&
          apiSource.mimetype_specific_metadata &&
          "page" in apiSource.mimetype_specific_metadata
            ? [apiSource.mimetype_specific_metadata.page as number]
            : undefined,
      };
    case "application/pdf":
      return {
        ...baseSource,
        mimetype: "application/pdf",
        pages:
          typeof apiSource.mimetype_specific_metadata === "object" &&
          apiSource.mimetype_specific_metadata &&
          "page" in apiSource.mimetype_specific_metadata
            ? [apiSource.mimetype_specific_metadata.page as number]
            : undefined,
      };
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return {
        ...baseSource,
        mimetype: apiSource.mimetype,
        htmlContent:
          typeof apiSource.mimetype_specific_metadata === "object" &&
          apiSource.mimetype_specific_metadata &&
          "html_content" in apiSource.mimetype_specific_metadata
            ? (apiSource.mimetype_specific_metadata.html_content as string)
            : undefined,
      };
    default:
      return {
        ...baseSource,
        mimetype: "application/pdf",
      };
  }
}
